import React from "react";
import { formatPhone } from "../../../js/shared/utils";

const urlUpdatePhoneMultiplus =
	"https://www.pontosmultiplus.com.br/portal/pages/meusDados/MeusDados.html";

export const ItemCardInfoPhoneMultiplus = ({ phoneMultiplus }) => {
	return (
		<div className="item-card-info-phone-multiplus">
			<p className="item-card-info-phone-multiplus--title">
				Atenção ao telefone cadastrado no Latam Pass!
			</p>
			<p className="item-card-info-phone-multiplus--first-text">
				A Latam envia um código via SMS para confirmar cada emissão de passagem.
				<br></br>
				<br></br>
				Para fazer sua venda, adicione o número <b>{formatPhone(phoneMultiplus)}</b> como telefone
				celular na sua conta Latam Pass,{" "}
				<a onClick={() => window.open(urlUpdatePhoneMultiplus, "_blank")}>clique aqui</a> para ver
				os detalhes dessa alteração.<br></br>
				<br></br>
				<p>
					Depois, é só atualizar este campo informando o número da MaxMilhas que você colocou no
					Latam Pass.
				</p>
				<br></br>
				<b>Se já tem um telefone da MaxMilhas cadastrado, é só aproveitar suas vendas!</b>
			</p>
			{!window.isWebview && (
				<button
					onClick={() => window.open(urlUpdatePhoneMultiplus, "_blank")}
					data-action="update-phone-multiplus"
					className="btn-primary-lg-o"
				>
					Alterar telefone no Latam Pass
				</button>
			)}
		</div>
	);
};
